import A11yMenu from './_a11yMenu';
import GLightbox from 'glightbox';

import {
	OverlayScrollbars,
	ScrollbarsHidingPlugin,
	ClickScrollPlugin,
	SizeObserverPlugin,
} from 'overlayscrollbars';

const initScrollbars = () => {
	const scrolls = document.querySelectorAll('.js-scrollbar');
	if (scrolls) {
		OverlayScrollbars.plugin([SizeObserverPlugin, ScrollbarsHidingPlugin, ClickScrollPlugin]);
		scrolls.forEach((elt) => {
			OverlayScrollbars(elt, {
				overflow: {
					y: 'hidden',
				},
				scrollbars: {
					theme: 'os-theme-dark',
					visibility: 'auto',
					clickScroll: true,
				},
			}, {
				updated(osInstance) {
					// For accessibility

					const scrollableDiv = osInstance.elements().content;
					if (osInstance.state().hasOverflow.x) {
						scrollableDiv.setAttribute('tabindex', 0);
						scrollableDiv.setAttribute('role', 'region');
						scrollableDiv.setAttribute('aria-label', 'Contenu avec scroll');
					} else {
						scrollableDiv.setAttribute('tabindex', -1);
						scrollableDiv.removeAttribute('role');
						scrollableDiv.removeAttribute('aria-label');
					}
				},
			});
		});
	}
};

const videoReduceMotion = () => {
	const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
	const bgVideos = document.querySelectorAll('video[muted][autoplay]');

	bgVideos.forEach((vid) => {
		const control = vid.parentElement.querySelector('.hero__control');
		if (control) {
			control.removeAttribute('hidden');

			if (prefersReducedMotion.matches) {
				control.classList.add('showAlways');
			}

			control.addEventListener('click', () => {
				if (vid.paused) {
					vid.play();
					control.querySelector('#hero__control__button').textContent = 'Pause';
					control.querySelector('.play').classList.add('hidden');
					control.querySelector('.pause').classList.remove('hidden');
				} else {
					vid.pause();
					control.querySelector('#hero__control__button').textContent = 'Play';
					control.querySelector('.pause').classList.add('hidden');
					control.querySelector('.play').classList.remove('hidden');
				}
			});
		}
	});

	if (prefersReducedMotion.matches) {
		bgVideos.forEach((vid) => {
			vid.pause();
		});
	}

	prefersReducedMotion.addEventListener('change', () => {
		if (prefersReducedMotion.matches) {
			bgVideos.forEach((vid) => {
				vid.pause();

				const control = vid.parentElement.querySelector('.hero__control');
				if (control) {
					control.removeAttribute('hidden');
				}
			});
		} else {
			bgVideos.forEach((vid) => {
				vid.play();
			});
		}
	});
};

const handlePopover = function handlePopover(button, popover) {
	button.addEventListener('click', () => {
		popover.showPopover();
		popover.focus();
	});

	button.addEventListener('keydown', (e) => {
		// enter key
		if (e.keyCode === 13) {
			popover.showPopover();
			popover.focus();
		}

		if (e.keyCode === 32) {
			e.preventDefault();
		}
	});

	button.addEventListener('keyup', (e) => {
		// space key
		if (e.keyCode === 32) {
			popover.showPopover();
			popover.focus();
		}
	});
};

const handleSticky = function handleSticky() {
	const hero = document.querySelector('.hero');
	const header = document.querySelector('header[role="banner"]');
	if (hero) {
		if (window.scrollY >= 50) {
			header.classList.add('colored');
		} else {
			header.classList.remove('colored');
		}
	}
};

document.addEventListener('DOMContentLoaded', () => {
	// Solve menu animation firing on page load
	const trItem = document.querySelector('.preload-animation');
	if (trItem) {
		window.setTimeout(() => {
			trItem.classList.remove('preload-animation');
		}, 640);
	}

	// Debounce the sticky menu
	let debounced;
	window.addEventListener('scroll', () => {
		window.clearTimeout(debounced);
		debounced = setTimeout(handleSticky, 100);
	});

	const menu = new A11yMenu(document.querySelector('.a11y-nav-block'), '81rem');
	menu.menuSetup();

	const adrNav = document.querySelector('.desktop-adr-nav');
	const adrNavTrigger = document.querySelector('.js-desktop-adr-nav');
	const adrNavContent = document.querySelector(`#${adrNavTrigger.getAttribute('aria-controls')}`);

	const isAdrNavOpened = () => adrNavContent.getAttribute('aria-hidden') === 'false';

	const openAdrNavTrigger = () => {
		adrNavContent.setAttribute('aria-hidden', false);
		adrNavContent.removeAttribute('inert');
		adrNavTrigger.setAttribute('aria-expanded', true);
	};

	const closeAdrNavTrigger = (focus = true) => {
		adrNavContent.setAttribute('aria-hidden', true);
		adrNavContent.setAttribute('inert', true);
		adrNavTrigger.setAttribute('aria-expanded', false);
		if (focus) {
			adrNavTrigger.focus();
		}
	};

	const handleClickOutsideAdrNav = (e) => {
		if (isAdrNavOpened() && !adrNav.contains(e.target)) {
			closeAdrNavTrigger(false);
		}
	};

	const handleKeyboard = (e) => {
		if (isAdrNavOpened()) {
			// Close on escape
			if (e.keyCode === 27) {
				closeAdrNavTrigger();
			}
		}
	};

	adrNavTrigger.addEventListener('click', () => {
		if (isAdrNavOpened()) {
			closeAdrNavTrigger();
		} else {
			openAdrNavTrigger();
		}
	});

	window.addEventListener('keydown', handleKeyboard);
	window.addEventListener('click', handleClickOutsideAdrNav);

	/* A11y for Hero video */
	videoReduceMotion();

	initScrollbars();

	const lightbox = GLightbox({
		touchNavigation: true,
		loop: true,
	});

	const openPopin = document.querySelectorAll('#openResaPopin');
	openPopin.forEach((div) => {
		const popover = document.querySelector('#popover_resa');

		const link = div.querySelector('a');
		const text = link.textContent;
		const linkAtts = Array.from(link.attributes);

		const button = document.createElement('button');
		button.textContent = text;

		linkAtts.forEach((element) => {
			const attr = element;
			// Transfer the attributes other than href.
			if (attr.name !== 'href' && attr.name !== 'tabindex') {
				button.setAttribute(attr.name, attr.value);
			}
		});

		div.replaceChild(button, link);

		handlePopover(button, popover);
	});
});
